import * as React from 'react';
import { Link } from 'react-router-dom';
import CheckUtils from '../../utilities/check-utils';
import { ProductCategory, ProductSubcategory } from '../../infrastructure/http/modules/product/product.models';
import TranslationsContext from '../../infrastructure/context/translations/translations-context';
import ITranslationsContext from '../../infrastructure/context/translations/translations-context.interface';
import TranslationManager from '../../infrastructure/translation-manager';
import { TranslationKeys } from '../../infrastructure/const';
import Spinner from '../common/spinner';
import { GetHttpClientInstance } from '../../infrastructure/context/http/http-context-provider';
import { Product } from '../../infrastructure/http/modules/product/product.models';
import ProductList from '../../components/product-list/product-list';
import { WebsiteIds } from '../../infrastructure/const';
import IConfigurationContext from '../../infrastructure/context/configuration/configuration.context.interface';
import ConfigurationContext from '../../infrastructure/context/configuration/configuration.context';

class CategoryMenuTilesProps {
  categories: ProductCategory[];
}

class CategoryMenuTilesState {
  productsList: Array<Product>;
  categoryName: string | null
  isLoaded: boolean;
  activeCategory: number | null
}

class CategoryMenuTiles extends React.Component<CategoryMenuTilesProps, CategoryMenuTilesState> {

    private translationManager: TranslationManager;

    constructor(props: CategoryMenuTilesProps, context: ITranslationsContext) {
        super(props);
        
        this.translationManager = new TranslationManager(context);

        let categoryName = props.categories && props.categories.length === 1? props.categories[0].url.substring(1, props.categories[0].url.length) : null;
        this.state = {
            productsList: [],
            categoryName: categoryName,
            isLoaded: !categoryName,
            activeCategory: null
        };
    }

    getCategoryProducts(routeQuery: string): void {
        GetHttpClientInstance().product.browse(routeQuery).then((result) => {
            if (!CheckUtils.isNullObject(result)) {
                this.setState(prevState =>{
                    return{
                        ...prevState,
                        productsList: result.products, 
                        isLoaded: true
                    }
                });
            }
        });
    }

    setActiveCategory(activeCategory: number | null): void {
        this.setState(prevState =>{
            return{
                ...prevState,
                activeCategory: activeCategory
            }
        });
    }

    componentDidMount(): void {
        if(this.state.categoryName) {
            this.getCategoryProducts(this.state.categoryName);
        }
    }


    renderMenu(): JSX.Element {
        return (
            <ConfigurationContext.Consumer>
                {(configurationContext: IConfigurationContext) =>
                    <>
                    {configurationContext.id === WebsiteIds.HorselshopSe && this.renderBrandsSubCategories()}
                    {(
                        configurationContext.id !== WebsiteIds.HorselshopSe) && <>
                            {!CheckUtils.isNullOrEmptyArray(this.props.categories) && this.props.categories.length > 1 && this.props.categories.map(element => (
                                this.renderMenuTile(element)
                            ))}
                            {(CheckUtils.isNullObject(this.state.productsList) || this.state.productsList.length === 0) ? 
                                null :
                                <ProductList products={this.state.productsList} />
                            }
                        </>
                    }
                    </>
                }
            </ConfigurationContext.Consumer>  
        );
    }


    renderMenuTile(category: ProductCategory): JSX.Element {
        return (
            <article className="category-menu-tile" key={category.id}>
                <Link to={category.url}>
                    <div className="category-menu-tile__img">
                        <img src={category.image} alt={category.title} />
                    </div>
                </Link>

                <div className="">
                    <Link to={category.url} className="">
                        <h5 className="category-menu-tile__product-name">
                            {category.title}
                        </h5>
                    </Link>
                </div>
            </article>
        );
    }


    renderBrandsSubCategories(): JSX.Element {
        if(this.state.activeCategory) {
           let brandCategory = this.props.categories.find(f=>f.id === this.state.activeCategory);            
            return <>
                <div className='wrapper'>
                    <button 
                        className="button btn-white btn-back" 
                        onClick={() => this.setActiveCategory(null)}>
                            {this.translationManager.getTranslation(TranslationKeys.MENUTILES_BACK)}
                    </button>
                </div> 
                
                {brandCategory && !CheckUtils.isNullOrEmptyArray(brandCategory.subcategories) && brandCategory.subcategories.map(subcategory => (
                    this.renderSubCategoryMenuTile(brandCategory as ProductCategory, subcategory)
                ))}
            </>       
        }

        return <>
            {!CheckUtils.isNullOrEmptyArray(this.props.categories) && this.props.categories.map(element => (
                this.renderBrandMenuTile(element)
            ))}
        </>
    }

    renderBrandMenuTile(category: ProductCategory): JSX.Element {
        return (
            <article className="category-menu-tile brand-tile" key={category.id} onClick={() => this.setActiveCategory(category.id)}>
                <div className="category-menu-tile__img">
                    <img src={category.image} alt={category.title} />
                </div>
                <div className="">
                    <h5 className="category-menu-tile__product-name">
                        {category.title}
                    </h5>
                </div>
            </article>
        );
    }

    renderSubCategoryMenuTile(category: ProductCategory, subCategory: ProductSubcategory): JSX.Element {
        return (
            <article className="category-menu-tile" key={subCategory.id}>
                <Link to={category.url + subCategory.url}>
                    <div className="category-menu-tile__img">
                        <img src={subCategory.image} alt={subCategory.title} />
                    </div>
                </Link>

                <div className="">
                    <Link to={subCategory.url} className="">
                        <h5 className="category-menu-tile__product-name">
                            {subCategory.title}
                        </h5>
                    </Link>
                </div>
            </article>
        );
    }


    render(): JSX.Element {
        return (
            <div className="category-top">
                <div className="wrapper category-menu">
                    <h2 className="category-menu__title">
                        {this.translationManager.getTranslation(TranslationKeys.MENUTILES_HEADER)}                                
                    </h2>
                    <div className="category-menu__list">      
                        {!this.state.isLoaded && <Spinner show />}
                        {this.state.isLoaded && this.renderMenu()}                            
                    </div>
                </div>
            </div>
        );
    }
}

CategoryMenuTiles.contextType = TranslationsContext;

export default CategoryMenuTiles;